export const API_URL = {
  /* START: auth service */
  // auth
  signin: "/authentication-service/v1/login",
  getMe: "/v1/auth/v1/profile/get-me",
  uploadFile: "/v1/auth/v1/upload-file",
  uploadMobileToken: "/v1/auth/v1/profile/update-mobile-token",

  /* START: Job post service */
  createJobPost: "/v1/job/v1/create",
  updateJobPost: "/v1/job/v1/update",
  deleteJobPost: "/v1/job/v1/delete",
  getAllJobPost: "/v1/job/v1/data",
  getSkillList: "/v1/job/v1/job-skill/data",
  getTagList: "/v1/job/v1/job-tags/data",
  getSingleJobPost: "/v1/job/v1/details",
  getJobAppliedList: "/v1/job/v1/job-applications/data",
  getSingleJobApplied: "/v1/job/v1/job-applications/details",
  hireJobApplication: "/v1/job/v1/job-applications/update-hire",
  closeJoPost: "/v1/job/v1/job-applications/close-by-organization",
  reviewAssignment: "/v1/job/v1/job-applications/review-assignment",

  /* START: Survey template service */
  createSurveyTemplate: "/v1/job/v1/survey-template/create",
  surveyTemplateUpdateBulkStatus: "/v1/job/v1/survey-template/bulk-status",
  updateSurveyTemplate: "/v1/job/v1/survey-template/update",
  getAllSurveyTemplate: "/v1/job/v1/survey-template/data",
  getSurveyTemplateDetails: "/v1/job/v1/survey-template/details",
  getSurveyAnswerList: "/v1/job/v1/survey-answers/data",
  getSurveyAnswerDetails: "/v1/job/v1/survey-answers/details",
  getSurveyData: "/v1/job/v1/survey-template-for-survey-data/data",
  getSurveyResponses:
    "/v1/job/v1/survey-data-survey-details/user-response-summary",
  getSurveyResponseByMember: "/v1/job/v1/survey-answers/data",
  updateSurveyAnswerStatus: "/v1/job/v1/survey-answers/bulk-status",

  // Payment
  getAllPayment: "/v1/job/v1/payments/data",
  sendToPayment: "/v1/job/v1/payments/send-to-payments",
  sendToPaymentPortal: "/v1/job/v1/payments/by-ids",

  // Notifications
  getAllNotification: "/v1/job/v1/notifications/data",
  notificationStatus: "/v1/job/v1/notifications/bulk-mark-as-read",

  // Dashboard
  getDashboardData: "/v1/job/v1/dashboard/stats",

  // Contractual -> Salary Slab
  getAllSalarySlab: "/v1/salary-slab/v1/data",
  getSingleSalarySlab: "/v1/salary-slab/v1/details",
  createSalarySlab: "/v1/salary-slab/v1/create",
  updateSalarySlab: "/v1/salary-slab/v1/update",

  // Contractual -> Setup KPI
  kpi: "/v1/kpi-setup/v1/groups",
  getKpiGroupsByJob: "/v1/kpi-setup/v1/job",
  giveKpiPerformance: "/v1/kpi-setup/v1/kpi-achievements/batch",
  getKPIAchievement: "/v1/kpi-setup/v1/kpi-achievements/batch",

  // Contractual -> Shift Management
  createShift: "/v1/shift-management/v1/create",
  updateShift: "/v1/shift-management/v1/update",
  deleteShift: "/v1/shift-management/v1/delete",
  getAllShift: "/v1/shift-management/v1/data",
  getSingleShift: "/v1/shift-management/v1/details",
  updateShiftGraceTime: "/v1/shift-management/v1/update-grace-period",
  resetShiftGraceTime: "/v1/shift-management/v1/reset-all-shift-grace-period",
  getShiftDetailsOverview: "/v1/shift-management/v1/overview",
  getShiftDetailsMemberOverview: "/v1/shift-management/v1",
  getShiftMembers: "/v1/shift-management/v1/shifts",

  // Contractual -> Attendance Management
  attendanceSettings: "/v1/attendance-management/v1/settings",
  getDailyAttendanceList: "/v1/attendance-management/v1/list",

  // Contractual -> Leave Management
  createLeaveAllocation: "/v1/leave-management/v1/allocations/create",
  updateLeaveAllocation: "/v1/leave-management/v1/allocations/update",
  deleteLeaveAllocation: "/v1/leave-management/v1/allocations/delete",
  getAllLeaveAllocation: "/v1/leave-management/v1/allocations/data",
  getLeaveAllocationByJob: "/v1/leave-management/v1/allocations/by-job",
  createLeaveRequest: "/v1/leave-management/v1/leave-requests",
  approveOrRejectLeaveRequest:
    "/v1/leave-management/v1/leave-requests/update-status",
  getAllLeaveRequest: "/v1/leave-management/v1/leave-requests/data",
  getLeaveRequestDetails: "/v1/leave-management/v1/leave-requests/details",
  getLeaveRequestByJob: "/v1/leave-management/v1/leave-requests/by-job",

  // My Projects -> Project Details -> Job Details
  getAllShiftHistory: "/v1/shift-management/v1/assignments/history",
  assignShift: "/v1/shift-management/v1/assign-shift",
  getAllSlabHistory: "/v1/salary-slab/v1/assigned",
  assignSalarySlab: "/v1/salary-slab/v1/assign",
  getAllKpiPerformanceHistory: "/v1/kpi-setup/v1/assignments",
  assignKpiGroup: "/v1/kpi-setup/v1",
  getAllContractHistory: "/v1/contract-management/v1/history",
  renewContract: "/v1/contract-management/v1/renew",

  // Contractual -> Payroll
  generatePayroll: "/v1/payroll/v1/generate",
  getAllKPIBatch: "/v1/kpi-setup/v1/batches",
  getKPIBatchDetails: "/v1/kpi-setup/v1/batches",
  getAllPayrollBatch: "/v1/payroll/v1/batches",
  getPayrollBatchDetails: "/v1/payroll/v1/batches",
  sentToDisbursement: "/v1/payroll/v1/batches/sent-to-disburse",
  getCompanyWallet: "/v1/payroll/v1/company-wallets",
  getPayrollBatchSummary: "/v1/payroll/v1/batch/summary",
};
